import initializePickers from '../plugins/PluginPicker.ts'

window.addEventListener('load', () => {
  initializePickers({
    activeIndexes: [],
    noSelected: true,
    activeClass: 'active',
    pickerSelector: '[data-picker="career"]',
    multiplePickerSelector: '',
    buttonSelector: '[data-picker-btn]',
    itemSelector: '[data-picker-item]',
  })

  const moreBrands = document.querySelectorAll(
    '[data-picker-item-more="brands"]',
  )

  if (moreBrands.length > 0) {
    moreBrands[0]?.classList.add('active')
  }

  const mediaQuery = window.matchMedia('(max-width: 991px)')

  if (mediaQuery.matches) {
    const btns = document.querySelectorAll('[data-picker-btn-desktop]')

    btns.forEach((btn) => {
      btn.removeAttribute('data-picker-btn')
    })
  }

  initializePickers({
    activeIndexes: [0],
    noSelected: false,
    activeClass: 'active',
    pickerSelector: '[data-picker="brands"]',
    multiplePickerSelector: '',
    buttonSelector: '[data-picker-btn]',
    itemSelector: '[data-picker-item]',
    onStateChange: (state) => {
      const items = state.element.querySelectorAll('[data-picker-item-more]')

      if (items.length === 0) return

      items.forEach((item) => {
        item?.classList.remove('active')

        items?.[state.activeIndexes[0]]?.classList.add('active')
      })
    },
  })

  const offerPage = document.querySelector('[data-item="offer"]')

  if (offerPage) {
    let offerIndex = 0
    const pathSegments = window.location.pathname.split('/')

    if (pathSegments) {
      const slug = pathSegments[pathSegments.length - 1].replace(/-$/, '')
      const categories = document.querySelectorAll('[data-offer]')

      categories.forEach((category, index) => {
        if (category.getAttribute('data-offer') === slug) {
          offerIndex = index
        }

        return
      })
    }

    const moreOffer = document.querySelectorAll('[data-picker-item-more]')
    const worksOffer = document.querySelectorAll('[data-picker-item-works]')
    const titleOffer = document.querySelectorAll('[data-picker-item-title]')

    if (
      moreOffer.length > 0 ||
      worksOffer.length > 0 ||
      titleOffer.length > 0
    ) {
      moreOffer[offerIndex]?.classList.add('active')
      worksOffer[offerIndex]?.classList.add('active')

      if (
        worksOffer[offerIndex]?.querySelectorAll('.works__item')?.length > 0
      ) {
        titleOffer[offerIndex]?.classList.add('active')
      }
    }

    initializePickers({
      activeIndexes: [offerIndex],
      noSelected: false,
      activeClass: 'active',
      pickerSelector: '[data-picker="offer"]',
      multiplePickerSelector: '',
      buttonSelector: '[data-picker-btn]',
      itemSelector: '[data-picker-item]',
      onStateChange: (state) => {
        const itemsMore = state.element.querySelectorAll(
          '[data-picker-item-more]',
        )
        const itemsWorks = state.element.querySelectorAll(
          '[data-picker-item-works]',
        )
        const itemsTitles = state.element.querySelectorAll(
          '[data-picker-item-title]',
        )

        if (
          itemsMore.length === 0 ||
          itemsWorks.length === 0 ||
          itemsTitles.length === 0
        )
          return

        itemsMore.forEach((item) => {
          item?.classList.remove('active')

          itemsMore?.[state.activeIndexes[0]]?.classList.add('active')
        })

        itemsWorks.forEach((item) => {
          item?.classList.remove('active')

          itemsWorks?.[state.activeIndexes[0]]?.classList.add('active')
        })

        itemsTitles.forEach((item, index) => {
          item?.classList.remove('active')

          if (
            itemsWorks[state.activeIndexes[0]]?.querySelectorAll('.works__item')
              ?.length > 0
          ) {
            itemsTitles?.[state.activeIndexes[0]]?.classList.add('active')
          }
        })
      },
    })
  }
})
